/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export type ApiQuery = {
  name: string;
  currentPage: number;
  pageLimit: number;
  sort: string;
  sortOrder: "asc" | "desc";
  totalPages?: number;
  totalItems?: number;
};

export async function getUsers({
  name = "",
  pageLimit = 10,
  currentPage = 1,
  sort = "createdAt",
  sortOrder = "desc",
}: ApiQuery ): Promise<any> {
  
  try {
    const response = await axiosInstance.get(`${config.apiUrl}/users`, {
      params: { search:name, sort, sortOrder, currentPage, pageLimit },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data.message || "Error fetching Users");
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}
